import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { is_superuser, picked_franchise_id, sees_all_franchises } from "../../Functionalities/Config";
import { ManageFranchise } from "../Franchise/Logic";

export const chosenFranchise = (query) => (sees_all_franchises ? query.get("franchise") || "" : picked_franchise_id);

export default function useFranchiseChoice(query, setQuery) {
  const [franchises, setFranchises] = useState([]);
  useEffect(() => {
    if (!sees_all_franchises) return;
    ManageFranchise("", "", "get", "page_wise=false&for_dropdown=true")
      .then((res) => setFranchises(Array.isArray(res && res.data) ? res.data : []))
      .catch(() => setFranchises([]));
  }, []);
  const franchiseId = chosenFranchise(query);
  const picker = sees_all_franchises ? (
    <Select
      style={{ minWidth: 220 }}
      placeholder="Pick a franchise"
      value={franchiseId ? Number(franchiseId) : undefined}
      options={franchises.map((f) => ({ value: f.id, label: f.name }))}
      onChange={(value) => setQuery({ franchise: value })}
      showSearch
      optionFilterProp="label"
    />
  ) : null;
  return { franchiseId, picker, ready: !is_superuser || Boolean(franchiseId) };
}
